<!--
 * @Author: Czy
 * @Date: 2021-08-24 09:06:19
 * @LastEditTime: 2022-03-25 11:56:39
 * @FilePath: /plant-protection-association/src/components/suspension.vue
 *  
-->
<template>
 <div class="suspension hidden-xs hidden-sm">
        <div class="suspension-item" v-for="(item , idx) in suspendedList" :key="idx" @click="goItem(item)">
                {{ item}}
        </div>
    </div>

       

   
</template>
<script>
import Vue from 'vue';
// 0094ff
export default {
    data() {
        return {
            suspendedList:[
                "我要参展", "我要参观", "我要合作", "我要投稿",
            ]
        }
    },
    methods:{
        goItem(type){
            switch (type) {
                case '我要参展':
                  return this.$emit("showModal",0)
                case '我要参观':
                    return  window.open('https://bm.phenixexhibition.com/gz/#/?t=1&c=audience',"_blank");
                case '我要合作':
                    return this.$emit("showModal",1)
                case '我要投稿':
                    return this.$emit("showModal",2)
                
                default:
                    break;
            }
        }
    }
}
</script>
<style lang="scss" scoped>

    .suspension{
        width:120px;
        height:250px;
        background-color: #fff;
        position:fixed;
        top: 300px;
        left:50px;
        z-index: 998;
        display:flex;
        flex-direction: column;
        justify-content:space-between;
        align-items: center;
        padding:20px 0;
       border-radius: 5px;
       box-shadow:0px 0px 5px #e1e1e1;
       
        .suspension-item{
            height:40px;
            width:100px;
            background-color: #fff;
            border: 1px solid #192989;
            border-radius: 8px;
            display:flex;
            justify-content:center;
            align-items: center;
            color: #192989;
            font-size:18px;
        }
        .susp-icon{
            // width: 100px;
            // height:200px;
            position: absolute;
            left:-24px;
            top:100px;
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/suspension.vue